class ProgramList {
    constructor(el) {
        this.el = el;
        this.concertItems = el.querySelectorAll('.-ticket');
        this.attachListeners();
    }

    attachListeners() {
        this.concertItems.forEach(item => item.addEventListener('click', event => {
            event.preventDefault();
        }));
    }
}

export default el => new ProgramList(el);
